<div class="selection">
  <rask-selector
    aid="inputHandelssotiment"
    label="{{'KUNDORDER_DETAIL_HANDELSSORTIMENT' | translate}}"
    class="col-lg-9"
    label="Alti"
    [(ngModel)]="selected"
    [required]="true"
    [search]="search"
    [viewFormatter]="formatter"
    [raskDisabledControl]="readonly">
  </rask-selector>
  <rask-button aid="buttonLaggTillAlternativa" class="col-lg-2"
    [disabled]="!canEdit() || !canAdd()" color="primary" (click)="add()">
  {{'KUNDORDER_DETAIL_ALTERNATIVA_MOTTAGNINGSPLATSER_LAGG_TILL' | translate }}</rask-button>
</div>

@if (alternativtHandelssortiment.length === 0) {
  <div>
    <hr />
    <p style="text-align:center">{{'KUNDORDER_DETAIL_ALTERNATIVA_HANDELSSORTIMENT_INGA_TILLAGDA' | translate }} </p>
  </div>
}

@if (alternativtHandelssortiment.length !== 0) {
  <ul>
    <rask-list [data]="alternativtHandelssortiment">
      <rask-list-column header="Namn" field="namn"></rask-list-column>
      <rask-list-column header="Manuell på ao" field="manuellPaAo">
        <ng-template let-row="row">
          <rask-checkbox
            [disabled]="!canEdit()"
            class="row-checkbox"
            [(ngModel)]="row.manuellPaAo"
            (change)="updateCommand(row)">
          </rask-checkbox>
        </ng-template>
      </rask-list-column>
      <rask-list-column header="Egenskapskod x" field="egenskapskodX">
        <ng-template let-row="row">
          <rask-checkbox
            [disabled]="!canEdit()"
            class="row-checkbox"
            [(ngModel)]="row.egenskapskodX"
            (change)="updateCommand(row)">
          </rask-checkbox>
        </ng-template>
      </rask-list-column>
    <rask-list-column header="Endast CK" field="endastck">
        <ng-template let-row="row">
        <rask-checkbox
            [disabled]="!canEditEndastCK(row)"
            class="row-checkbox"
            [(ngModel)]="row.endastCentralaKop"
            (change)="updateCommand(row)">
        </rask-checkbox>
        </ng-template>
    </rask-list-column>
    <rask-list-column header="Inmätningshandelssortiment" field="inmatningshandelssortiment">
        <ng-template let-row="row">
        <rask-selector
            [ngClass]="{'row-selector': true}"
            [reverseLookup]="false"
            class="col-lg-12"
            [search]="searchForHandelssortiment"
            placeholder="{{ handelssortimentViewFormatter(row.beraknatInmatningshandelssortiment) }}"
            [ngModel]="row.inmatningshandelssortiment"
            (ngModelChange)="onSelectChange(row, $event)"
            [viewFormatter]="handelssortimentViewFormatter"
            [disabled]="!canEdit()">
        </rask-selector>
        </ng-template>
    </rask-list-column>
      <rask-list-column header="" field="">
        <ng-template let-row="row">
          <rask-icon-button (click)="delete(row)" color="tertiary" icon="far fa-trash-alt" negative
          [disabled]="!canEdit()"></rask-icon-button>
        </ng-template>
      </rask-list-column>
    </rask-list>
    @for (error of errors; track error; let index = $index) {
      <div class="row">
        <rask-validation-message-row [message]="error" type="error">
        </rask-validation-message-row>
      </div>
    }
  </ul>
}
